export const name = 'libraryDeleteController';
export default function LibraryDeleteController($mdDialog, $log, assetsLibService, errorDialogOpen, analyticsFactory, $translate) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.cancel = cancel;
  vm.delete = deleteAssetLibrary;
  vm.isInProgress = false;
  vm.numOfLibrariesToDelete = vm.listOfAssetsLibraries.length;

  $translate.onReady(function() {
    vm.confirmDeletionTranslation = $translate.instant('imposer.composer-main.Templates_DeleteConfirm').replace('{0}', vm.numOfLibrariesToDelete);
  });

  function cancel(data) {
    let functionName='LibraryDeleteController.cancel';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.cancel();

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function deleteAssetLibrary() {
    let functionName='LibraryDeleteController.deleteAssetLibrary';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    vm.isInProgress = true;

    assetsLibService.deleteAssetLibraries(vm.listOfAssetsLibraries).then(function () {
      $log.info(angular.toJson({action:'Asset libraries deleted successfully', functionName:functionName}));
      analyticsFactory.eventTrack(analyticsFactory.actions.assetLibrariesDeletion, analyticsFactory.categories.composer, analyticsFactory.labels.success, null);
      $mdDialog.hide();
    }, function(status) {
      errorDialogOpen.openErrorDialog(status);
      $log.info(angular.toJson({action:'error deleting asset libraries', functionName:functionName}));
      analyticsFactory.eventTrack(analyticsFactory.actions.assetLibrariesDeletion, analyticsFactory.categories.composer, analyticsFactory.labels.failure, null);
      $mdDialog.hide();
    });

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }
}
